/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { WageCalculationBonusesData } from '../models/wage-calculation-bonuses-data';
import { WageCalculationData } from '../models/wage-calculation-data';

@Injectable({
  providedIn: 'root',
})
export class WageCalculationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation wageCalculationPost
   */
  static readonly WageCalculationPostPath = '/api/WageCalculation/Post';

  /**
   * Bérkalkuláció létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCalculationPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  wageCalculationPost$Plain$Response(params?: {
    body?: {
'UserId'?: number;
'ProjectId'?: number;
'Expiration'?: string;
'CacheKey'?: string;
'RequestUserId'?: number;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<WageCalculationData>> {

    const rb = new RequestBuilder(this.rootUrl, WageCalculationService.WageCalculationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WageCalculationData>;
      })
    );
  }

  /**
   * Bérkalkuláció létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCalculationPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  wageCalculationPost$Plain(params?: {
    body?: {
'UserId'?: number;
'ProjectId'?: number;
'Expiration'?: string;
'CacheKey'?: string;
'RequestUserId'?: number;
}
  },
  context?: HttpContext

): Observable<WageCalculationData> {

    return this.wageCalculationPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<WageCalculationData>) => r.body as WageCalculationData)
    );
  }

  /**
   * Bérkalkuláció létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCalculationPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  wageCalculationPost$Response(params?: {
    body?: {
'UserId'?: number;
'ProjectId'?: number;
'Expiration'?: string;
'CacheKey'?: string;
'RequestUserId'?: number;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<WageCalculationData>> {

    const rb = new RequestBuilder(this.rootUrl, WageCalculationService.WageCalculationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WageCalculationData>;
      })
    );
  }

  /**
   * Bérkalkuláció létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCalculationPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  wageCalculationPost(params?: {
    body?: {
'UserId'?: number;
'ProjectId'?: number;
'Expiration'?: string;
'CacheKey'?: string;
'RequestUserId'?: number;
}
  },
  context?: HttpContext

): Observable<WageCalculationData> {

    return this.wageCalculationPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<WageCalculationData>) => r.body as WageCalculationData)
    );
  }

  /**
   * Path part for operation wageCalculationGet
   */
  static readonly WageCalculationGetPath = '/api/WageCalculation';

  /**
   * Bérkalkuláció adatainak lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCalculationGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCalculationGet$Plain$Response(params?: {
    Id?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<WageCalculationData>> {

    const rb = new RequestBuilder(this.rootUrl, WageCalculationService.WageCalculationGetPath, 'get');
    if (params) {
      rb.query('Id', params.Id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WageCalculationData>;
      })
    );
  }

  /**
   * Bérkalkuláció adatainak lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCalculationGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCalculationGet$Plain(params?: {
    Id?: string;
  },
  context?: HttpContext

): Observable<WageCalculationData> {

    return this.wageCalculationGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<WageCalculationData>) => r.body as WageCalculationData)
    );
  }

  /**
   * Bérkalkuláció adatainak lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCalculationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCalculationGet$Response(params?: {
    Id?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<WageCalculationData>> {

    const rb = new RequestBuilder(this.rootUrl, WageCalculationService.WageCalculationGetPath, 'get');
    if (params) {
      rb.query('Id', params.Id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WageCalculationData>;
      })
    );
  }

  /**
   * Bérkalkuláció adatainak lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCalculationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCalculationGet(params?: {
    Id?: string;
  },
  context?: HttpContext

): Observable<WageCalculationData> {

    return this.wageCalculationGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<WageCalculationData>) => r.body as WageCalculationData)
    );
  }

  /**
   * Path part for operation wageCalculationGetBonuses
   */
  static readonly WageCalculationGetBonusesPath = '/api/WageCalculation/GetBonuses';

  /**
   * Bérkalkuláció bónuszok lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCalculationGetBonuses$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCalculationGetBonuses$Plain$Response(params?: {
    ProjectId?: number;
    UserId?: number;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<WageCalculationBonusesData>> {

    const rb = new RequestBuilder(this.rootUrl, WageCalculationService.WageCalculationGetBonusesPath, 'get');
    if (params) {
      rb.query('ProjectId', params.ProjectId, {});
      rb.query('UserId', params.UserId, {});
      rb.query('RequestUserId', params.RequestUserId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WageCalculationBonusesData>;
      })
    );
  }

  /**
   * Bérkalkuláció bónuszok lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCalculationGetBonuses$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCalculationGetBonuses$Plain(params?: {
    ProjectId?: number;
    UserId?: number;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<WageCalculationBonusesData> {

    return this.wageCalculationGetBonuses$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<WageCalculationBonusesData>) => r.body as WageCalculationBonusesData)
    );
  }

  /**
   * Bérkalkuláció bónuszok lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCalculationGetBonuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCalculationGetBonuses$Response(params?: {
    ProjectId?: number;
    UserId?: number;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<WageCalculationBonusesData>> {

    const rb = new RequestBuilder(this.rootUrl, WageCalculationService.WageCalculationGetBonusesPath, 'get');
    if (params) {
      rb.query('ProjectId', params.ProjectId, {});
      rb.query('UserId', params.UserId, {});
      rb.query('RequestUserId', params.RequestUserId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WageCalculationBonusesData>;
      })
    );
  }

  /**
   * Bérkalkuláció bónuszok lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCalculationGetBonuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCalculationGetBonuses(params?: {
    ProjectId?: number;
    UserId?: number;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<WageCalculationBonusesData> {

    return this.wageCalculationGetBonuses$Response(params,context).pipe(
      map((r: StrictHttpResponse<WageCalculationBonusesData>) => r.body as WageCalculationBonusesData)
    );
  }

  /**
   * Path part for operation wageCalculationCheckValidationCode
   */
  static readonly WageCalculationCheckValidationCodePath = '/api/WageCalculation/CheckValidationCode';

  /**
   * Felhasználó hozzáférésének ellenőrzése az adott projekthez.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCalculationCheckValidationCode$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCalculationCheckValidationCode$Plain$Response(params?: {
    UserId?: number;
    ProjectId?: number;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, WageCalculationService.WageCalculationCheckValidationCodePath, 'get');
    if (params) {
      rb.query('UserId', params.UserId, {});
      rb.query('ProjectId', params.ProjectId, {});
      rb.query('RequestUserId', params.RequestUserId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Felhasználó hozzáférésének ellenőrzése az adott projekthez.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCalculationCheckValidationCode$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCalculationCheckValidationCode$Plain(params?: {
    UserId?: number;
    ProjectId?: number;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<boolean> {

    return this.wageCalculationCheckValidationCode$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Felhasználó hozzáférésének ellenőrzése az adott projekthez.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCalculationCheckValidationCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCalculationCheckValidationCode$Response(params?: {
    UserId?: number;
    ProjectId?: number;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, WageCalculationService.WageCalculationCheckValidationCodePath, 'get');
    if (params) {
      rb.query('UserId', params.UserId, {});
      rb.query('ProjectId', params.ProjectId, {});
      rb.query('RequestUserId', params.RequestUserId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Felhasználó hozzáférésének ellenőrzése az adott projekthez.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCalculationCheckValidationCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCalculationCheckValidationCode(params?: {
    UserId?: number;
    ProjectId?: number;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<boolean> {

    return this.wageCalculationCheckValidationCode$Response(params,context).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

}
